var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('requests-section',{attrs:{"requests":_vm.requests},on:{"setRequestsPage":_vm.getRequests}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }